// extracted by mini-css-extract-plugin
export default {"Box":"EditIssues-module__Box--eK5kJ","Octicon":"EditIssues-module__Octicon--FVf44","Text":"EditIssues-module__Text--gil9m","Text_1":"EditIssues-module__Text_1--mK4xp"};